import { _ as __rest } from './tslib.es6-9c37295f.js';
import React__default, { useState, useRef, useMemo, useEffect } from 'react';
import { BabyBoyMB, BabyGirlMB } from '@hhgtech/icons/other';
import { createStyles, rem, Box, Flex } from '@mantine/core';
import { R as Radio } from './index-3d331313.js';
import '@mantine/dates';
import './index-120855f6.js';
import './index-ed3e7858.js';
import { C as CommonGAssets } from './index-d943196d.js';
import './useMantineLocale-69ff962c.js';
import { T as Text } from './index-bca4f215.js';
import './index-5b1256a3.js';
import './index.styles-d00e47f8.js';
import { u as useTranslations } from './index-ef9bdc70.js';
import '@mantine/hooks';
import './utils-da0db738.js';
import './other-82ea32cf.js';
import './index-72b06055.js';

var useStyles = createStyles((theme, { type }) => {
    const isMarryBaby = theme.other.template === 'mb';
    return {
        root: {},
        wrapper: Object.assign({ gap: rem(8) }, (type === 'radio' && {
            justifyContent: 'flex-end',
            gap: rem(24),
        })),
        groupErr: {
            fontSize: rem(14),
        },
        itemRoot: Object.assign({}, (type === 'button'
            ? {
                flexGrow: 1,
                width: '50%',
                '&[data-checked="true"]': {
                    '.mantine-Radio-label': {
                        borderColor: theme.fn.primaryColor(),
                    },
                },
            }
            : type === 'radio'
                ? { padding: `${rem(10)} 0`, margin: 0 }
                : {})),
        itemLabelWrapper: {
            padding: 0,
            width: '100%',
        },
        itemLabel: Object.assign({ whiteSpace: 'nowrap' }, (type === 'button'
            ? {
                position: 'relative',
                padding: `${rem(6)} ${rem(16)}`,
                border: `1px solid ${isMarryBaby ? '#EAEAEC' : theme.colors.gray[2]}`,
                borderRadius: rem(isMarryBaby ? 16 : 4),
                cursor: 'pointer',
                '&[data-disabled="true"]': {
                    background: theme.colors.gray[1],
                    color: `${theme.colors.gray[4]} !important`,
                    img: {
                        opacity: 0.5,
                    },
                },
                img: {
                    height: rem(26),
                },
            }
            : type === 'radio'
                ? { fontSize: rem(14) }
                : {})),
        itemInner: Object.assign(Object.assign({}, (type === 'button' && {
            display: 'none',
        })), (type === 'radio' && {
            alignSelf: 'center',
        })),
        itemBody: Object.assign({}, (type === 'radio' && {
            alignItems: 'center',
        })),
    };
});

const GenderOptionControl = (_a) => {
    var { label, availableValue: availableValueInit, styles, isBaby, genderValue = {
        male: 'male',
        female: 'female',
    }, type = 'button', hideLabel } = _a, radioProps = __rest(_a, ["label", "availableValue", "styles", "isBaby", "genderValue", "type", "hideLabel"]);
    const { t } = useTranslations();
    const { classes, cx, theme } = useStyles({ type }, {
        name: 'GenderOptionControl',
        styles,
    });
    const isMarryBaby = theme.other.template === 'mb';
    const [availableValue, setAvailableValue] = useState();
    const ref = useRef(null);
    const genderOptions = useMemo(() => [
        {
            value: genderValue.male,
            label: isBaby ? t('gender.boy') : t('gender.male'),
            icon: isBaby ? (isMarryBaby ? (React__default.createElement(BabyBoyMB, null)) : (CommonGAssets.getAssetPath('health-tools/boy-icon.svg'))) : (CommonGAssets.getAssetPath('health-tools/male-icon.svg')),
        },
        {
            value: genderValue.female,
            label: isBaby ? t('gender.girl') : t('gender.female'),
            icon: isBaby ? (isMarryBaby ? (React__default.createElement(BabyGirlMB, null)) : (CommonGAssets.getAssetPath('health-tools/girl-icon.svg'))) : (CommonGAssets.getAssetPath('health-tools/female-icon.svg')),
        },
    ], []);
    useEffect(() => {
        setAvailableValue(availableValueInit);
    }, [availableValueInit]);
    return (React__default.createElement(Box, { ref: ref, className: classes.root },
        React__default.createElement(Radio.Group, Object.assign({ className: "radio-group", label: !hideLabel ? (React__default.createElement(Text, { as: "label", size: "s4", weight: "semiBold" }, label ||
                (isBaby
                    ? t('tools.selectBabyGender')
                    : t('tools.selectGender')))) : undefined, size: "lg" }, radioProps, { classNames: {
                error: classes.groupErr,
            } }, (type === 'radio' && {
            error: null,
        })),
            React__default.createElement(Flex, { className: cx(classes.wrapper) }, genderOptions.map((i) => (React__default.createElement(Radio, Object.assign({ className: "gender-item", size: "sm", classNames: {
                    root: classes.itemRoot,
                    labelWrapper: classes.itemLabelWrapper,
                    label: classes.itemLabel,
                    inner: classes.itemInner,
                    body: classes.itemBody,
                }, key: i.value, value: i.value }, (availableValue &&
                i.value !== availableValue && {
                disabled: true,
            }), { label: React__default.createElement(Flex, { gap: rem(8), align: 'center', justify: 'center', sx: { zIndex: 0 } },
                    type === 'button' &&
                        (typeof i.icon === 'string' ? (React__default.createElement("img", { src: i.icon, className: "gender-image", alt: "female", loading: "lazy" })) : (i.icon)),
                    React__default.createElement(Text, { size: "p3" }, i.label)) }))))))));
};

export { GenderOptionControl as G };
